<template>
  <div>
    <common-header></common-header>
    <PageHeader title="Server Status"></PageHeader>
    <div class="container py-10">
      <div class="login-container max-w-md mx-auto">
        <div class="rounded-lg bg-gray-100 p-10 Sample">
          <ServerInfo></ServerInfo>
        </div>
      </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import PageHeader from  '@/components/commons/PageHeader.vue'
import ServerInfo from '@/components/modules/ServerInfo.vue'

export default{
  name:"ServerStatus",
  components:{
    PageHeader,
    ServerInfo
  },
  mounted(){},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
